import {IDataSourceAdapter} from '~/lib/dataSource';
import {fetchPayments} from '~/modules/Payments/api';
import {IPayment} from '~/modules/Payments/models/Payment';

export const paymentsAdapter: IDataSourceAdapter<IPayment> = {
    fetchRecords: fetchPayments
};
